import globalUseStyles from '../../../../styles/globalCustomStyles';

import { Card, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useGetList, useRecordContext, useTranslate } from 'react-admin';
import InfoTooltipIcon from "../../../../assets/InfoTooltipIcon";
import CustomTooltip from '../../../aegeon/CustomTooltip';
import ChartLoading from '../../../aegeon/charts/ChartLoading';
import ChartNoData from '../../../aegeon/charts/ChartNoData';
import { is_value_defined } from '../../../aegeon/helper';

const SiteEnergeticPerformanceDeet = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();
  const { type, isGraph, data, isLoading, colors } = props;
  const record = useRecordContext(props);
  const siteId = record?.id;
  const [value, setValue] = useState(null);
  const { data: devices } = useGetList(
    'devices',
    {
      filter: {
        siteIds: { contains: siteId },
      },
    }
  );

  useEffect(() => {
    if (data?.performances && !value) {
      const perf = data.performances.find((p) => p.type === type)
      if (perf && is_value_defined(perf.value)) {
        let value = Math.round(perf.value * 100) / 100 + " " + perf.unit;
        setValue(value);
      }
    }
  }, [data, type, value]);

  const title = t('sites.energetic_performance.' + type + '.title');
  const subtitle = t('sites.energetic_performance.' + type + '.subtitle');
  const tooltip_text = t('sites.energetic_performance.' + type + '.tooltip_text');

  return (
    <Card className={globalClasses.DetailCard}>
      <div className={globalClasses.energeticPerfsTitles}>
        <div className={globalClasses.DetailCardTableTitle}>
          <Typography variant="h8">{title}</Typography>
          <CustomTooltip title={tooltip_text} icon={<InfoTooltipIcon />} />
        </div>
        <div className={globalClasses.DetailCardTableSubtitle}>
          {subtitle}
        </div>
      </div>
      <div>
        {isLoading ? <ChartLoading /> :
          !value ? <ChartNoData /> :
            <div className={globalClasses.energeticPerfCards}>
              <Typography variant="h3" component="div" color={type == 'DEET_GHG' ? colors["ghg"] : colors["energy"]} className={globalClasses.compositionText}>
                {value}
              </Typography>
            </div>
        }
      </div>
    </Card>
  )
};

export default SiteEnergeticPerformanceDeet; 